export const processComparisonData = (data, tableName) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const todayData = data?.filter(item => {
        const itemDate = new Date(item.DateTime || item.Datetime);
        itemDate.setHours(0, 0, 0, 0);
        return itemDate.getTime() === today.getTime();
    }) || [];

    const yesterdayData = data?.filter(item => {
        const itemDate = new Date(item.DateTime || item.Datetime);
        itemDate.setHours(0, 0, 0, 0);
        return itemDate.getTime() === yesterday.getTime();
    }) || [];

    if (tableName.toLowerCase() === 'mohali') {
        return {
            today: {
                power1hr: sumValues(todayData, 'EM_POWER_PRE_1HR'),
                power24hr: sumValues(todayData, 'EM_POWER_PRE_24HR')
            },
            yesterday: {
                power1hr: sumValues(yesterdayData, 'EM_POWER_PRE_1HR'),
                power24hr: sumValues(yesterdayData, 'EM_POWER_PRE_24HR')
            }
        };
    }
    if (tableName.toLowerCase() === 'laxmi-organics') {
        return {
            today: {
                feed: sumValues(todayData, 'FEED_FLOW_TOT_CUR_1H_LAXMI3'),
                cond: sumValues(todayData, 'COND_FLOW_TOT_CUR_1H_LAXMI3'),
                power: sumValues(todayData, 'EM_POWER_TOT_CUR_1H_LAXMI3')
            },
            yesterday: {
                feed: sumValues(yesterdayData, 'FEED_FLOW_TOT_CUR_1H_LAXMI3'),
                cond: sumValues(yesterdayData, 'COND_FLOW_TOT_CUR_1H_LAXMI3'),
                power: sumValues(yesterdayData, 'EM_POWER_TOT_CUR_1H_LAXMI3')
            }
        };
    }
    if (tableName.toLowerCase() === 'ks-textile') {
        return {
            today: {
                feed: sumValues(todayData, 'FEED_FLOW_PRE_1H_TOT_KS'),
                cond: sumValues(todayData, 'COND_FLOW_PRE_1H_TOT_KS'),
                power: sumValues(todayData, 'POWER_PRE_1H_TOT_KS')
            },
            yesterday: {
                feed: sumValues(yesterdayData, 'FEED_FLOW_PRE_1H_TOT_KS'),
                cond: sumValues(yesterdayData, 'COND_FLOW_PRE_1H_TOT_KS'),
                power: sumValues(yesterdayData, 'POWER_PRE_1H_TOT_KS')
            }
        };
    }
    if (tableName.toLowerCase() === 'baddi') {
        return {
            today: {
                power1hr: sumValues(todayData, 'Baddi_Power_PRE_1h_TOT'),
                power2hr: sumValues(todayData, 'EM2_POWER_PRE_1H_TOT_HMI')
            },
            yesterday: {
                power1hr: sumValues(yesterdayData, 'Baddi_Power_PRE_1h_TOT'),
                power2hr: sumValues(yesterdayData, 'EM2_POWER_PRE_1H_TOT_HMI')
            }
        };
    }

    return {
        today: {
            feed: sumValues(todayData, findKey(todayData[0], 'FEED')),
            cond: sumValues(todayData, findKey(todayData[0], 'COND')),
            power: sumValues(todayData, findKey(todayData[0], 'POWER'))
        },
        yesterday: {
            feed: sumValues(yesterdayData, findKey(yesterdayData[0], 'FEED')),
            cond: sumValues(yesterdayData, findKey(yesterdayData[0], 'COND')),
            power: sumValues(yesterdayData, findKey(yesterdayData[0], 'POWER'))
        }
    };
};

const sumValues = (data, key) => {
    return data.reduce((sum, item) => sum + (Number(item[key]) || 0), 0);
};

const findKey = (obj, type) => {
    if (!obj) return '';
    return Object.keys(obj).find(key => 
        key.toUpperCase().includes(type.toUpperCase())
    ) || '';
};

export const formatDateTime = (dateTime) => {
    if (!dateTime) return '-';
    // Remove the .000Z and replace T with space
    return dateTime.replace('T', ' ').split('.')[0];
};

export const parseDateTime = (dateTime) => {
    if (!dateTime) return null;
    return new Date(dateTime);
};
